import React from "react";
import Flex from "@/components/layout/Flex";
import { breakpointClasses, cn, splitBreakpointProps } from "@/lib/utils";
import type { CardFooterProps } from "../types";

function CardFooter({ className, ...props }: CardFooterProps) {
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  return (
    <Flex
      data-slot="card-footer"
      direction="column"
      justify="start"
      items="center"
      className={cn("flex-grow p-6", className, classes)}
      {...native}
    />
  );
}

CardFooter.displayName = "Card.Footer";

export default CardFooter;
